import type { AsType } from '@jwplayer/wui-components';
import { useMemo } from 'react';

import { StatusStore } from '/global-state/status';

export function useSystemStatusIndicator() {
  const systemStatus = StatusStore.useState((s) => s.systemStatus);

  const statusOptions = useMemo(() => {
    switch (systemStatus?.indicator) {
      case 'none':
        return {
          icon: 'check',
          label: 'Operational',
          type: 'green',
        } as const;
      case 'minor':
        return {
          icon: 'alert-circle',
          label: 'Degraded performance',
          type: 'yellow',
        } as const;
      case 'major':
        return {
          icon: 'alert-circle',
          label: 'Partial outage',
          type: 'yellow',
        } as const;
      case 'critical':
        return {
          icon: 'alert-triangle-filled',
          label: 'Major outage',
          type: 'red',
        } as const;
      case 'maintenance':
        return {
          icon: 'info-circle',
          label: 'Maintenance',
          type: 'blue',
        } as const;
      default:
    }
  }, [systemStatus]);

  return {
    ...statusOptions,
    as: [
      'a',
      {
        href: 'https://status.jwplayer.com/',
        target: '_blank',
      },
    ] as AsType<'a'>,
  } as const;
}
